export default __webpack_public_path__ + "static/media/Pitsenbargers.9005245a.jpg";